import { Utilities } from "./utilities";

export interface EmailOptions
{
    readonly subject: string;
    readonly message?: string;
    readonly recipient?: string;
    readonly target?: string;
}

export class EmailUtilities
{
    /**
     * @deprecated Use send with options object.
     * @param _unused NOT USED.
     * @param target URL fragment to an app to be embedded in the email message.
     * @param subject
     * @param message
     * @param recipient
     */
    share(_unused: never, target: string, subject: string, message: string, recipient: string): void
    {
        this.send({
            subject,
            message: !!message && message !== "" ? message : "",
            recipient: !!recipient && recipient !== "" ? recipient : "",
            target,
        });
    }

    send(options: EmailOptions): void
    {
        const lines: Array<string> = [
            options.message || ""
        ];

        const recipient = options.recipient || "";

        if (options.target)
        {
            const pathname = window.location.pathname;
            const targetBase = pathname.substring(0, pathname.lastIndexOf("apps/") + 5);

            const link = `<${window.location.origin}${targetBase}${options.target}>`;
            lines.push(" " + link);
        }

        const message = encodeURIComponent(
            lines.join("")
                .trim());
        const subject = options.subject ? encodeURIComponent(options.subject) : null;

        let url = `mailto:${recipient}`;
        let bodyModifier = "?";
        if (!Utilities.IsNullOrUndefinedOrEmpty(subject))
        {
            url += `?subject=${subject}`;
            bodyModifier = "&";
        }
        if (!Utilities.IsNullOrUndefinedOrEmpty(message))
            url += `${bodyModifier}body=${message}`;
        location.href = url;
    }
}
export const EmailShare = new EmailUtilities();
